import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';

export default function CpfRatioBox(props) {
  const {
    carbohydrate,
    protein,
    fat,
    text,
    ...rest
  } = props || {};
  return (
    <VBox {...ex(['CpfRatioBox', { text }], rest)} full>
      <div>
        {T('{0}-{1}-{2}', carbohydrate, protein, fat)}
      </div>
      <HBox full>
        <div {...{ style: { backgroundColor: '#5F9FFF', width: T('{0}%', carbohydrate) } }} />
        <div {...{ style: { backgroundColor: '#FF8B70', width: T('{0}%', protein) } }} />
        <div {...{ style: { backgroundColor: '#FFCA7E', width: T('{0}%', fat) } }} />
      </HBox>
    </VBox>
  );
}
